const allChart = {}

async function sleep(ms) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(true)
    }, ms)
  });
}

function arrNotEmpty(arr = []) {
  let result = false

  for(let item of arr) {
    if ((item.value && item.value !== '-') || item.value === 0) {
      result = true
      break;
    }
  }
  return result
}

export {allChart, sleep, arrNotEmpty}